import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

import { EventType } from '../models/broadcast-auth-event.interface';
import { TOKEN_API } from '../tokens';

import { BroadcastService } from './broadcast.service';
import { IAuthorizationResponseContract } from '../models/authorization';

@Injectable()
export class LoginService {
  constructor(
    private http: HttpClient,
    private broadcastService: BroadcastService,
  ) {}

  public login(username: string, password: string) {
    const headers = new HttpHeaders().append(
      'Content-Type',
      'application/x-www-form-urlencoded',
    );

    return this.http
      .post<IAuthorizationResponseContract>(
        TOKEN_API,
        'grant_type=password&username=' +
          encodeURIComponent(username) +
          // tslint:disable-next-line:no-hardcoded-credentials
          '&password=' +
          encodeURIComponent(password),
        { headers },
      )
      .pipe(
        tap((payload) => {
          this.broadcastService.emit({
            type: EventType.LOGIN_SUCCESS,
            payload,
          });
        }),
      );
  }
}
